import { saveFileChanges } from "./saveFileChanges";
// import { saveToFirestore } from "./saveToFirestore";
import { updateStorageInFirestore } from "./updateStorageInFirestore";
import { db } from "./../firebase";
import { doc, deleteDoc } from "firebase/firestore";

export async function onDeleteProject(project) {
  project.Files.forEach((f) => {
    f.deleted = true;
  });
  const sfc = await saveFileChanges(project.Files, project.uid, project.id);
  
  //Save storage changes
  if (sfc.sizeChange !== 0) {
    await updateStorageInFirestore(project.uid, sfc.sizeChange);
  }

  // 1. Get a reference to the document
  const docRef = doc(db, "projects", project.id);
  // 2. Delete the document and await the promise
  await deleteDoc(docRef);

  console.log(`Document with ID: ${project.id} successfully deleted!`);
}
